module.exports = __webpack_public_path__ + "media/bootstrap-icons/clouds-fill-1d20a10c.svg";